import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant19PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black }, ref)=>jsx("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2160 1304",
        children: jsx("path", {
            ref: ref,
            d: "M134.786 269.3c138.808-35.867 267.88-118.753 415.84-106.398 112.317 9.341 215.317 91.258 228.431 207.939 13.889 122.964-69.342 249.267-28.159 365.966 34.088 96.472 148.06 147.948 249.662 135.523 101.59-12.426 190.36-75.857 261.01-149.859 70.64-74.001 127.83-159.96 196.98-235.376 64.02-69.785 145.59-133.242 240.24-136.964 91.52-3.653 178.95 52.212 228.63 129.222 49.61 77.027 65.21 171.963 60.54 263.464-6.83 134.729-43.81 278.093-92.67 403.213",
            stroke: color,
            strokeWidth: 220,
            strokeMiterlimit: 10,
            strokeLinecap: "round"
        })
    }));

export { Variant19PathwayIllustration as default };
